// extracted by mini-css-extract-plugin
module.exports = {"root":"IconLabel_root__cH2a8","icon":"IconLabel_icon__GhuyK","text":"IconLabel_text__cxWi9"};